import { Helmet } from 'react-helmet-async'

interface SEOProps {
  title: string
  description: string
  keywords?: string
  canonical: string
  ogTitle?: string
  ogDescription?: string
  ogImage?: string
  noindex?: boolean
  jsonLd?: object | object[]
}

const DEFAULT_OG_IMAGE = 'https://onitsoft.com/1200x630.png'

const SEO: React.FC<SEOProps> = ({
  title,
  description,
  keywords,
  canonical,
  ogTitle,
  ogDescription,
  ogImage = DEFAULT_OG_IMAGE,
  noindex = false,
  jsonLd,
}) => {
  const resolvedOgTitle = ogTitle ?? title
  const resolvedOgDescription = ogDescription ?? description

  const jsonLdArray = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : []

  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description} />
      {keywords && <meta name='keywords' content={keywords} />}
      <meta name='robots' content={noindex ? 'noindex, nofollow' : 'index, follow'} />
      <link rel='canonical' href={canonical} />

      {/* Open Graph */}
      <meta property='og:type' content='website' />
      <meta property='og:locale' content='pl_PL' />
      <meta property='og:site_name' content='ONITSOFT' />
      <meta property='og:title' content={resolvedOgTitle} />
      <meta property='og:description' content={resolvedOgDescription} />
      <meta property='og:url' content={canonical} />
      <meta property='og:image' content={ogImage} />
      <meta property='og:image:width' content='1200' />
      <meta property='og:image:height' content='630' />
      <meta property='og:image:alt' content={resolvedOgTitle} />

      {/* Twitter */}
      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:title' content={resolvedOgTitle} />
      <meta name='twitter:description' content={resolvedOgDescription} />
      <meta name='twitter:image' content={ogImage} />

      {/* JSON-LD */}
      {jsonLdArray.map((schema, i) => (
        <script key={i} type='application/ld+json'>
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  )
}

export default SEO
